import React from 'react'
import {Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {PAYMENT_COLORS} from './constants'
import {formatRelativeTime, GatewayMetricsSummary} from './types'

export default function GatewayMetrics({
  metrics,
  isLoading,
}: {
  metrics?: GatewayMetricsSummary | null
  isLoading?: boolean
}) {
  const {t} = useTranslation()

  if (isLoading) {
    return (
      <Typography fontSize={13} color={PAYMENT_COLORS.textMuted}>
        {t('payment.metrics.loading') as string}
      </Typography>
    )
  }

  if (!metrics) {
    return null
  }

  const last = formatRelativeTime(metrics.last_transaction, t('payment.metrics.never') as string)

  return (
    <Stack gap='4px'>
      <Typography fontSize={13} color={PAYMENT_COLORS.textSecondary}>
        {t('payment.metrics.transactions') as string}: {metrics.total_transactions}
      </Typography>
      <Typography fontSize={13} color={PAYMENT_COLORS.textSecondary}>
        {t('payment.metrics.success_rate') as string}: {metrics.success_rate}%
      </Typography>
      <Typography fontSize={13} color={PAYMENT_COLORS.textSecondary}>
        {t('payment.metrics.last_activity') as string}: {last}
      </Typography>
    </Stack>
  )
}
